import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BaseComponent } from '@shared/components/base-component/base.component';
import { startWith, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-zero-shipment-prices',
  templateUrl: './zero-shipment-prices.component.html',
  styleUrls: ['./zero-shipment-prices.component.scss'],
})
export class ZeroShipmentPricesComponent extends BaseComponent {
  @Input() form: FormGroup;
  @Input() value = false;
  @Output() isZeroShipmentPriceSelected = new EventEmitter<boolean>();

  constructor() {
    super();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['form'] && changes['form'].currentValue !== changes['form'].previousValue) {
      this.addFormControls();
    }
  }

  handleZeroPricesChanges(useZeroPrices: boolean) {
    this.isZeroShipmentPriceSelected.emit(useZeroPrices);
  }

  addFormControls() {
    this.form.addControl('isZeroShipmentPrice', new FormControl(this.value, Validators.required));
    this.form.controls['isZeroShipmentPrice'].valueChanges
      .pipe(startWith(this.value),takeUntil(this.destroy$))
      .subscribe((isZeroShipmentPriceSelected) => {
        this.handleZeroPricesChanges(isZeroShipmentPriceSelected);
      });
  }

}
